import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { endpoints } from '../endpoints';
import { CodeMultipleHierarchyPicker } from '../../common';
import { userGroupCodetableId } from '../constants';
import { CodeMultiplePickerProps } from './types';
import { getValidationWithoutDuplicates } from './helpers';
import { manageOptionsUserGroup } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeUserGroups = (props: CodeMultiplePickerProps) => {

  const { metadata, codeItem, codetableId, displaySelectAll, options,
    translation, validation, readOnly, locale,
    onChange, loadOptions } = props;

  if (!metadata || !metadata.features || !metadata.features.userGroup) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoints.userGroup, { ...loadOptionsParams, optionsCollectionId: codetableId });
  };

  const extraFooterButton = manageOptionsUserGroup(translation.manage_options);

  const codeOptions = (!!options && !!options.userGroups && options.userGroups.codes || []) as CodeComplexValue<number>[];

  const userGroupsValidation = !!validation && !!validation.subset ? getValidationWithoutDuplicates(validation.subset) : undefined;

  return <>
    <CodeMultipleHierarchyPicker
      id="userGroups"
      label={codetableId === userGroupCodetableId
        ? translation.available_for_current_user_group
        : translation.visible_for_user_groups}
      valueItems={codeItem && codeItem.userGroups}
      validation={userGroupsValidation}
      locale={locale}
      readOnly={readOnly}
      displaySelectAll={displaySelectAll}
      options={codeOptions}
      fetchingOptions={options && options.userGroups && options.userGroups.fetching}
      translation={translation}
      extraFooterButton={extraFooterButton}
      onLoadOptions={onLoadOptions}
      onChange={onChange}
    />
  </>;
};
